/**
 * @generated SignedSource<<eb59e2e3bca3cf48cb8975ebc9fd443e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateExpenseNatureInputObject = {
  color?: string | null | undefined;
  name: string;
  parentId?: string | null | undefined;
  perspectiveId: string;
};
export type naturePivotPage_CreateMutation$variables = {
  input: CreateExpenseNatureInputObject;
};
export type naturePivotPage_CreateMutation$data = {
  readonly createExpenseNature: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly expenseNature: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type naturePivotPage_CreateMutation = {
  response: naturePivotPage_CreateMutation$data;
  variables: naturePivotPage_CreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "naturePivotPage_CreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateExpenseNatureMutationPayload",
        "kind": "LinkedField",
        "name": "createExpenseNature",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "naturePivotPage_CreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateExpenseNatureMutationPayload",
        "kind": "LinkedField",
        "name": "createExpenseNature",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a15e989ca68d091f5cafd908155d0cc4",
    "id": null,
    "metadata": {},
    "name": "naturePivotPage_CreateMutation",
    "operationKind": "mutation",
    "text": "mutation naturePivotPage_CreateMutation(\n  $input: CreateExpenseNatureInputObject!\n) {\n  createExpenseNature(input: $input) {\n    expenseNature {\n      id\n      name\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af4b84b42576e39224f8a4a2bed43bba";

export default node;
